import { render, staticRenderFns } from "./CreditsRechargeModal.vue?vue&type=template&id=445d8534&scoped=true"
import script from "./CreditsRechargeModal.vue?vue&type=script&lang=js"
export * from "./CreditsRechargeModal.vue?vue&type=script&lang=js"
import style0 from "./CreditsRechargeModal.vue?vue&type=style&index=0&id=445d8534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445d8534",
  null
  
)

export default component.exports